import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';

import { useIsAbleToProceed } from '»utils/customHooks/useIsAbleToProceed';

import { menusSlice } from '../_menus.slice';
import {
  FontAwesomeIconStyled,
  ListItemIconStyled,
  RootListItemButtonStyled,
} from '../Menu.styles';
import {
  getActiveMenuItemSelector,
  getActiveNavigationMenuItemSelector,
  getMainMenu,
  isMenuOpened,
} from '../menus.selectors';

export const WalletMenuItem = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const activeNavigationMenuItem = useSelector(
    getActiveNavigationMenuItemSelector,
  );
  const isOpen = useSelector(isMenuOpened);
  const mainMenu = useSelector(getMainMenu);

  const available = mainMenu.some((el) => el.optionId === 'TRLT_PORTFOLIO');

  const { isAbleToProceed } = useIsAbleToProceed();
  const OPTION_ID = 'WALLET';
  const handleClickLeafMenu = (event, menuItem) => {
    isAbleToProceed(event, () => {
      dispatch(
        menusSlice.actions.setActiveMenuItem({ activeMenuItem: menuItem }),
      );
      dispatch(
        menusSlice.actions.setActiveNavigationMenuItem({
          activeNavigationMenuItem: '',
        }),
      );
    });
  };

  if (!available) return null;

  return (
    <RootListItemButtonStyled
      onClick={(event) => handleClickLeafMenu(event, OPTION_ID)}
      component={NavLink}
      to="/Wallet"
      selected={activeMenuItem?.includes(OPTION_ID)}
      isActiveNavigationMenuItemEmpty={activeNavigationMenuItem === ''}
      isOpen={isOpen}
      id="btnMenuPortfolio"
    >
      <ListItemIconStyled>
        <FontAwesomeIconStyled
          icon={faWallet}
          selected={activeMenuItem?.includes(OPTION_ID)}
        />
      </ListItemIconStyled>
      <ListItemText primary={<FormattedMessage id="TRLT_UI-PORTFOLIO" />} />
    </RootListItemButtonStyled>
  );
};
WalletMenuItem.propTypes = {
  isOpen: PropTypes.bool,
  available: PropTypes.bool,
  activeMenuItem: PropTypes.string,
  activeNavigationMenuItem: PropTypes.string,
  setActiveMenuItem: PropTypes.func,
  setActiveNavigationMenuItem: PropTypes.func,
};
